import { render, staticRenderFns } from "./BtnAdicionarProdutoInsumos.vue?vue&type=template&id=696a5598&"
import script from "./BtnAdicionarProdutoInsumos.vue?vue&type=script&lang=js&"
export * from "./BtnAdicionarProdutoInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports